import Contents from './contents'
import ContentsCounter from './counter'

class Container {
  constructor (target, index) {
    this.target = target
    this.index = index
    this.counters = []
    this.matchedFilter = ''

    this.contents = new Contents(
      this.target.querySelectorAll('[data-filter-content]'),
      target.getAttribute('data-filter-limit')
    )
    this.moreButton = document.getElementsByClassName('product-filter__more-btn')[index]
    this.filterButtonsContainer = document.getElementsByClassName('inline-filters__buttons-wrap')[index]
    this.filterButtons = this.target.querySelectorAll('[data-filter-btn]')
    this.setup()
  }

  setup () {
    this.target.querySelectorAll('[data-filters-counter-plural]').forEach(el => {
      this.counters.push(new ContentsCounter(el))
    })

    this.filterButtons.forEach(el => {
      el.addEventListener('click', e => { this.handleFilterButtonClick(e) })
    })

    this.moreButton.addEventListener('click', e => { this.handleMoreButtonClick(e) })

    if (window.location.hash) {
      this.filter(window.location.hash.substr(1))
    } else {
      this.filterAll()
    }
  }

  handleMoreButtonClick () {
    this.contents.renderByFilter(this.matchedFilter, true)
    this.moreButton.style.display = 'none'
  }

  filter (filterSlug) {
    const chip = this.filterButtonsContainer.querySelector(`[data-filter-btn="${filterSlug}"]`)
    if (!chip) {
      this.filterAll()
      return
    }

    this.setActiveChip(chip)
    this.filterContents(filterSlug)
  }

  filterAll () {
    this.filterContents('all')
  }

  handleFilterButtonClick (event) {
    this.setActiveChip(event.target)
    this.filterContents(event.target.getAttribute('data-filter-btn'))
  }

  setActiveChip (element) {
    this.filterButtons.forEach(el => { el.classList.remove('chip--active') })
    element.classList.add('chip--active')
  }

  filterContents (filter) {
    this.matchedFilter = filter
    this.contents.renderByFilter(filter)
    this.counters.forEach(c => { c.render(this.contents.numFiltered) })

    this.moreButton.style.display = ((this.contents.limit > 0 && this.contents.limit < this.contents.numFiltered) ? 'block' : 'none')
  }
}

const filterContainers = document.getElementsByClassName('inline-filters')
Array.from(filterContainers).forEach(function setupFilters (filterContainer, index) {
  window.inlineFilter = new Container(filterContainer, index)
})
